/* eslint-disable react/jsx-no-target-blank */
import { useEffect } from 'react'
import { ILayout, useLayout } from '../../core'
import { LanguageHelp } from '../../../../_metronic/helpers/LanguageHelper'

const Footer = () => {
  const { config } = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])
  return (
    <>
      <div className='text-dark order-2 order-md-1'>
        {LanguageHelp('Copyright')}
        <span className='text-muted fw-semibold me-1'>
          &nbsp;&copy; 2022
        </span>
        <a
          href='https://www.aisenseus.net/'
          target='_blank'
          className='text-gray-800 text-hover-primary'
        >
          AISenseUs
        </a>
      </div>

      <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
        {/* <li className='menu-item'>
          <a href='https://www.aisenseus.net/about' target='_blank' className='menu-link px-2'>
            {LanguageHelp('About Us')}
          </a>
        </li> */}

        <li className='menu-item'>
          <a href='https://www.aisenseus.net/contact' target='_blank' className='menu-link px-2'>
            {LanguageHelp('Contact Us')}
          </a>
        </li>

      </ul>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export { Footer }
